(function () {
  function setHidden(element, isHidden) {
    if (!element) return;
    element.hidden = isHidden;
  }

  function closeMega(root, options) {
    var trigger = root.querySelector('[data-sh-nav-mega-trigger]');
    var panel = root.querySelector('[data-sh-nav-mega-panel]');
    var scrim = root.querySelector('[data-sh-nav-mega-scrim]');

    window.clearTimeout(root.shNavCloseTimer);
    window.clearTimeout(root.shNavOpenTimer);
    root.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    setHidden(panel, true);
    setHidden(scrim, true);

    if (options && options.restoreFocus && trigger) {
      trigger.focus();
    }
  }

  function openMega(root) {
    var trigger = root.querySelector('[data-sh-nav-mega-trigger]');
    var panel = root.querySelector('[data-sh-nav-mega-panel]');
    var scrim = root.querySelector('[data-sh-nav-mega-scrim]');

    window.clearTimeout(root.shNavCloseTimer);
    window.clearTimeout(root.shNavOpenTimer);
    document.querySelectorAll('[data-sh-nav-mega].is-open').forEach(function (openRoot) {
      if (openRoot !== root) closeMega(openRoot);
    });

    root.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    setHidden(panel, false);
    setHidden(scrim, false);

    if (typeof window.shResetBedBathFilters === 'function') {
      window.shResetBedBathFilters(root);
    }
  }

  function scheduleOpen(root) {
    window.clearTimeout(root.shNavCloseTimer);
    root.shNavOpenTimer = window.setTimeout(function () {
      openMega(root);
    }, 80);
  }

  function scheduleClose(root) {
    window.clearTimeout(root.shNavOpenTimer);
    root.shNavCloseTimer = window.setTimeout(function () {
      closeMega(root);
    }, 160);
  }

  function initMega(root) {
    var trigger = root.querySelector('[data-sh-nav-mega-trigger]');
    var panel = root.querySelector('[data-sh-nav-mega-panel]');
    var scrim = root.querySelector('[data-sh-nav-mega-scrim]');
    var supportsHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (!trigger) return;

    trigger.addEventListener('click', function () {
      if (root.classList.contains('is-open')) {
        closeMega(root);
      } else {
        openMega(root);
      }
    });

    if (scrim) {
      scrim.addEventListener('click', function () {
        closeMega(root);
      });
    }

    if (supportsHover) {
      trigger.addEventListener('mouseenter', function () {
        scheduleOpen(root);
      });

      trigger.addEventListener('mouseleave', function () {
        scheduleClose(root);
      });

      if (panel) {
        panel.addEventListener('mouseenter', function () {
          window.clearTimeout(root.shNavCloseTimer);
        });

        panel.addEventListener('mouseleave', function () {
          scheduleClose(root);
        });
      }

    }
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-sh-nav-mega].is-open').forEach(function (root) {
      if (!root.contains(event.target)) closeMega(root);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-sh-nav-mega].is-open').forEach(function (root) {
      closeMega(root, { restoreFocus: true });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sh-nav-mega]').forEach(initMega);
  });
})();
